//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { areaList } from '@vant/area-data';
import AddSelectWay from './AddSelectWay'
const toolbarOptions = [
    // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
    ['bold', 'italic', 'underline', 'strike'],
    // 引用  代码块-----['blockquote', 'code-block']
    // ['blockquote', 'code-block'],
    // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
    // [{ header: 1 }, { header: 2 }],
    // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
    // [{ list: 'ordered' }, { list: 'bullet' }],
    // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
    // [{ script: 'sub' }, { script: 'super' }],
    // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
    // [{ indent: '-1' }, { indent: '+1' }],
    // 文本方向-----[{'direction': 'rtl'}]
    // [{ direction: 'rtl' }],
    // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
    [{ size: ['small', false, 'large', 'huge'] }],
    // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
    // [{ header: [1, 2, 3, 4, 5, 6, false] }],
    // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
    [{ color: [] }, { background: [] }],
    // 字体种类-----[{ font: [] }]
    // [{ font: [] }],
    // 对齐方式-----[{ align: [] }]
    // [{ align: [] }],
    // 清除文本格式-----['clean']
    // ['clean'],
    // 链接、图片、视频-----['link', 'image', 'video']
    ['image']
]
export default {
    components: {
        AddSelectWay,
        areaList,
        Treeselect
    },
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),

            valueTree: null,
            // define options
            optionsTree: [
                {
                    id: '类型',
                    label: '类型',
                    children: [
                        {
                            id: '1类型',
                            label: '乡村'
                        },
                        {
                            id: '2类型',
                            label: '目的地'
                        },
                        {
                            id: '3类型',
                            label: '景点'
                        }
                    ]
                },
                {
                    id: '玩法',
                    label: '玩法',
                    children: [
                        {
                            id: '1玩法',
                            label: '寻访'
                        },
                        {
                            id: '2玩法',
                            label: '越野'
                        },
                        {
                            id: '3玩法',
                            label: '爬山'
                        },
                        {
                            id: '4玩法',
                            label: '徒步'
                        },
                        {
                            id: '5玩法',
                            label: '摄影'
                        },
                        {
                            id: '6玩法',
                            label: '滑雪'
                        },
                        {
                            id: '7玩法',
                            label: '越野'
                        }
                    ]
                },
                {
                    id: '业务推广',
                    label: '业务推广',
                    children: [
                        {
                            id: '1业务推广',
                            label: '热门'
                        },
                        {
                            id: '2业务推广',
                            label: '推荐'
                        },
                        {
                            id: '3业务推广',
                            label: '清真'
                        },
                        {
                            id: '4业务推广',
                            label: '红色旅游'
                        },
                        {
                            id: '5业务推广',
                            label: '特色街区'
                        },
                        {
                            id: '6业务推广',
                            label: '精选'
                        },
                        {
                            id: '7业务推广',
                            label: '网红'
                        },
                        {
                            id: '8业务推广',
                            label: '乡村置顶'
                        },
                        {
                            id: '9业务推广',
                            label: '乡村推荐'
                        },
                        {
                            id: '10业务推广',
                            label: '首推'
                        },
                        {
                            id: 'a业务推广',
                            label: '置顶'
                        },
                        {
                            id: 'b业务推广',
                            label: '最热'
                        },
                        {
                            id: 'c业务推广',
                            label: '精华'
                        },

                    ]
                },
                {
                    id: '主题',
                    label: '主题',
                    children: [
                        {
                            id: '1主题',
                            label: '自驾游'
                        },
                        {
                            id: '2主题',
                            label: '周边游'
                        },
                        {
                            id: '3主题',
                            label: '养生游'
                        },
                        {
                            id: '4主题',
                            label: '美食游'
                        },
                        {
                            id: '5主题',
                            label: '观演游'
                        },
                        {
                            id: '6主题',
                            label: '修学游'
                        },
                        {
                            id: '7主题',
                            label: '研学游'
                        },
                        {
                            id: '8主题',
                            label: '冰雪游'
                        },
                        {
                            id: '9主题',
                            label: '采风游'
                        },
                        {
                            id: 'a主题',
                            label: '民俗游'
                        },
                        {
                            id: 'b主题',
                            label: '乡村游'
                        },
                        {
                            id: 'c主题',
                            label: '蜜月游'
                        },
                        {
                            id: 'd主题',
                            label: '团体游'
                        },

                    ]
                }
            ],
            Fcontent: '',
            name1: '',
            name2: '',
            name3: '',
            editorOption: {
                modules: {
                    toolbar: toolbarOptions
                },
                theme: 'snow',
                placeholder: '请输入正文'
                // Some Quill optiosn...
            },
            isShow: false,
            isShowEdit: false,
            flag: false,
            qillInit: true,
            names: '',
            digit: '',
            currentActive: '0',
            strategyLists: [],
            areaValue: '',
            showArea: false,
            areaList,

            moduleItem: {
                name: '游记名称XXX',
                typeLists: [
                    {
                        name: '游记内容',
                        icon: 'dd',
                        type: 'gk',
                        children: [
                            {
                                name: '写在开头',
                                key: 'header',
                                value: ''
                            },
                            // {
                            //   name: '行程信息',
                            //   key: 'tripInfo',
                            //   value: ''
                            // },
                            // {
                            //   name: '当地介绍',
                            //   key: 'localInfo',
                            //   value: ''
                            // }
                        ],
                        sitesLists: [
                            {
                                name: '泸沽湖假日酒店',
                                distance: '1.5km',
                                address: '盐源县泸沽湖镇木垮村',
                                img: require('@/assets/image/tourist/scenic.png')
                            },
                            {
                                name: '泸沽湖假日酒店2',
                                distance: '1.5km',
                                address: '盐源县泸沽湖镇木垮村',
                                img: require('@/assets/image/tourist/scenic.png')
                            },
                            {
                                name: '泸沽湖假日酒店3',
                                distance: '1.5km',
                                address: '盐源县泸沽湖镇木垮村',
                                img: require('@/assets/image/tourist/scenic.png')
                            }
                        ]
                    },
                    // {
                    //   name: '交通',
                    //   icon: 'jt',
                    //   type: 'jt',
                    //   children: [
                    //     {
                    //       name: '交通信息',
                    //       key: 'trafficInfo',
                    //       value: ''
                    //     },
                    //     {
                    //       name: '交通建议',
                    //       key: 'trafficSuggest',
                    //       value: ''
                    //     }
                    //   ],
                    //   sitesLists: []
                    // },
                    {
                        name: '住宿',
                        icon: 'house',
                        type: 'zs',
                        children: [
                            {
                                name: '住宿信息',
                                key: 'houseInfo',
                                value: ''
                            },
                            {
                                name: '住宿建议',
                                key: 'houseSuggest',
                                value: ''
                            }
                        ],
                        sitesLists: []
                    },
                    {
                        name: '美食',
                        icon: 'food',
                        type: 'ms',
                        children: [
                            {
                                name: '餐馆名称',
                                key: 'hotelName',
                                value: ''
                            },
                            {
                                name: '菜品推荐',
                                key: 'dishesCommend',
                                value: ''
                            },
                            {
                                name: '人均消费',
                                key: 'perperson',
                                value: ''
                            }
                        ],
                        sitesLists: []
                    },
                    {
                        name: '景区',
                        icon: 'jd',
                        type: 'jd',
                        children: [
                            {
                                name: '景点信息',
                                key: 'scenicInfo',
                                value: ''
                            },
                            {
                                name: '景点建议',
                                key: 'scenicSuggest',
                                value: ''
                            }
                        ],
                        sitesLists: [],
                        dlIndex: 0,
                    }
                ]
            },
            moduleItem2: {
                name: '游记名称XXX',
                typeLists: [
                    {
                        name: '关联游记',
                        icon: 'dd',
                        type: 'gk',
                        children: [
                            {
                                name: '333333333333',
                                key: 'jt',
                                value: '333'
                            },
                        ],
                    },
                    // {
                    //   name: '交通',
                    //   icon: 'jt',
                    //   type: 'jt',
                    //   children: [
                    //     {
                    //       name: '交通信息',
                    //       key: 'trafficInfo',
                    //       value: ''
                    //     },
                    //     {
                    //       name: '交通建议',
                    //       key: 'trafficSuggest',
                    //       value: ''
                    //     }
                    //   ],
                    //   sitesLists: []
                    // },


                ]
            }
        }
    },
    mounted() {
        // this.$refs.myLQuillEditor.quill.enable(false)
        console.log(this.$route.query.id);
        this.getInfo()



    },
    methods: {
        treeClose(value) {
            this.$tools.setStorage('tag2', value)
        },
        handleEditAblequestion() {
            if (this.qillInit) {
                // this.$refs.myLQuillEditor.quill.enable(true)
                // this.$refs.myLQuillEditor.quill.focus()
                this.qillInit = false
            }
        },
        // 失去焦点事件
        onEditorBlur(e) {
            // console.log('onEditorBlur: ', e)
        },
        // 获得焦点事件
        onEditorFocus(e) {
            // console.log('onEditorFocus: ', e)
        },
        // 内容改变事件
        onEditorChange(e) {
            this.$tools.setStorage('zhaiyao2', this.Fcontent)
        },
        onChange(e) {
            this.$tools.setStorage('2gl1', this.name1)
        },
        onChange2(e) {
            this.$tools.setStorage('2gl2', this.name2)
        },
        onChange3(e) {
            this.$tools.setStorage('2gl3', this.name3)
        },
        onConfirm(values) {
            this.areaValue = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join('/');
            this.showArea = false;
            this.$tools.setStorage('areaa2', this.areaValue)

        },
        isWrite(type) {
            return this.$tools.getStorage(type)
        },
        // getInfo (type) {
        //   // console.log(JSON.parse(this.isWrite(type)));
        //   return this.isWrite(type) ? JSON.parse(this.$tools.getStorage(type)) : null

        // },
        // 删除段落
        handleDelete(index) {
            if (this.strategyLists.length != 0) {
                this.$dialog.confirm({
                    title: '提示',
                    message: '确认删除该段落？'
                }).then(() => {
                    // this.strategyLists=[]
                    this.strategyLists.splice(index, 1)
                    this.$tools.setStorage('glyj2', this.strategyLists)
                    // this.$tools.removeStorage('glyj')
                })
            }
        },
        getGlDetail(id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/wtcp-traveltips/tipSelf/getDetailTip?id=${id}&access_token=${this.userInfo ? this.userInfo.access_token : ''}`, {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                        }
                    })
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getInfo() {
            this.getGlDetail(this.$route.query.id)
                .then((response) => {
                    this.name1 = response.data.title
                    this.name2 = response.data.subTitle
                    this.name3 = response.data.shareTitle
                    this.Fcontent = response.data.summary
                    this.areaValue = response.data.regionName.replace(/[,]/g, '/')
                    let tagList = response.data.tipTagsListModel.list
                    tagList.forEach((item, index) => {
                        item.id = index
                        item.label = item.tagName
                    });
                    this.valueTree = tagList

                    let newModuleItem = {}

                    response.data.tipCatalogListModel.list.forEach((item, index) => {
                        // console.log(item);
                        newModuleItem = JSON.parse(JSON.stringify(this.moduleItem2))
                        newModuleItem.name = item.title
                        newModuleItem.des = item.description
                        newModuleItem.sortNum = item.sortNum
                        newModuleItem.yjList = []
                        item.noteList.forEach((item2, index2) => {
                            newModuleItem.yjList.push({})
                            newModuleItem.yjList[index2].link = item2.link
                            // newModuleItem.yjList[index2].description = item2.description
                            newModuleItem.yjList[index2].sortNum = Number(item2.sortNum)
                            newModuleItem.yjList[index2].noteId = item2.noteId
                            newModuleItem.yjList[index2].title = item2.title
                        });
                        this.strategyLists.push(newModuleItem)
                        this.strategyLists.sort((a, b) => {
                            return b.sortNum - a.sortNum
                        })
                    });
                    // console.log(this.strategyLists);

                }).then(() => {
                    if (this.$tools.getStorage('tag2')) {
                        this.valueTree = JSON.parse(this.$tools.getStorage('tag2'))

                    }
                    if (this.$tools.getStorage('glyj2')) {
                        this.strategyLists = JSON.parse(this.$tools.getStorage('glyj2'))

                    }
                    if (this.$tools.getStorage('2gl1')) {
                        this.name1 = this.$tools.getStorage('2gl1')
                    }
                    if (this.$tools.getStorage('2gl2')) {
                        this.name2 = this.$tools.getStorage('2gl2')
                    }
                    if (this.$tools.getStorage('2gl3')) {
                        this.name3 = this.$tools.getStorage('2gl3')
                    }
                    if (this.$tools.getStorage('zhaiyao2')) {
                        this.Fcontent = this.$tools.getStorage('zhaiyao2')

                    }
                    if (this.$tools.getStorage('areaa2')) {
                        this.areaValue = this.$tools.getStorage('areaa2')
                    }
                })
        },
        // 编辑段落名称
        handleEdit(x, index) {
            this.digit = x.sortNum
            this.names = x.name
            this.isShowEdit = true
            this.dlIndex = index
        },
        // 确认段落名称
        handleConfirmName() {
            if (!this.names) {
                this.$dialog.alert({
                    title: '提示',
                    message: '请输入段落名称！'
                })
                return false
            }

            if (this.digit) {
                this.strategyLists[this.dlIndex].sortNum = this.digit
            }
            this.strategyLists[this.dlIndex].name = this.names
            this.strategyLists.sort((a, b) => {
                return b.sortNum - a.sortNum
            })
            this.$tools.setStorage('glyj2', this.strategyLists)
            this.names = ''
            this.digit = ''
            this.isShowEdit = false
        },
        // 添加段落
        handleAdd() {
            // if (this.strategyLists.length === 10) {
            //   this.$dialog.alert({
            //     title: '提示',
            //     message: '最多只允许添加10个游记'
            //   }).then(() => {
            //     return false
            //   })
            //   return false
            // }
            this.isShow = true
        },
        // 确认选择的游记
        handleConfirm(list, obj) {
            let newModuleItem = {}

            newModuleItem = JSON.parse(JSON.stringify(this.moduleItem2))
            newModuleItem.name = obj.name
            newModuleItem.des = obj.des
            newModuleItem.sortNum = obj.sortNum
            newModuleItem.exist = false
            newModuleItem.yjList = []
            console.log(list);
            list.forEach((item, index) => {
                newModuleItem.yjList.push({})
                newModuleItem.yjList[index].link = item.id
                newModuleItem.yjList[index].description = item.summary
                newModuleItem.yjList[index].sortNum = Number(item.sortNum)
                newModuleItem.yjList[index].noteId = item.id
                newModuleItem.yjList[index].title = item.title
            });
            this.strategyLists.push(newModuleItem)
            this.strategyLists.sort((a, b) => {
                return b.sortNum - a.sortNum
            })
            this.$tools.setStorage('glyj2', this.strategyLists)
            console.log(this.strategyLists);
            this.isShow = false
        },
        // 取消添加段落
        handleCancel() {
            this.isShow = false
        },
        jumpPage(item, index) {
            // if(index != 3){
            //   this.$tools.setStorage('input', item.children)
            // this.$router.push({
            //   name: 'writeDetail',
            //   query: {
            //     type: item.type,
            //     pageType: 'gn'
            //   }
            // })
            // }else{
            // this.$tools.setStorage('input', item.children)
            this.showArea = true
            // }
        }
    }
}
